import Accounting from 'accounting';
import vueSlider from 'vue-slider-component';
import AdvertisingDisclosures from '~/components/v2/advertising-disclosures.vue';
import DoughnutChart from '~/components/v2/doughnut-chart.vue';
import DropDown from '~/components/v2/drop-down.vue';
import LtLabel from '~/components/v2/lt-label.vue';
import LtLogo from '~/components/v2/lt-logo.vue';
import NumberInput from '~/components/v2/number-input.vue';
import LoanTermList from '~/constants/v2/loan-term-list';
import DefaultTooltip from '~/constants/v2/tooltip-defaults';
import ChartTooltip from '~/helpers/v2/chart-tooltip';
import CalculatorHelper from '~/helpers/v2/payment';
import BaseMixin from '~/mixin/v2/base-mixin';
import TokenService from '~/services/v2/token';

export default {
    props: {
        labelAnnualIncome: {
            default: 'Annual Income',
        },
        labelMonthlyExpenses: {
            default: 'Monthly Debt',
        },
        labelDownPayment: {
            default: 'Down Payment',
        },
        labelEstCreditScore: {
            default: 'Est. Credit Score',
        },
        customizeButtonText: {
            default: 'Customize',
        },
        labelLoanType: {
            default: 'Loan Type',
        },
        labelLoanTerm: {
            default: 'Loan Term',
        },
        labelMortgageRate: {
            default: 'Mortgage Rate',
        },
        labelPropertyTaxes: {
            default: 'Annual Property Taxes',
        },
        labelHomeInsurance: {
            default: 'Annual Home Insurance',
        },
        labelHoaFees: {
            default: 'HOA Fees',
        },
        labelMonthlyHoaFees: {
            default: 'Monthly HOA Fees',
        },
        annualIncome: {
            default: '65000',
        },
        monthlyExpenses: {
            default: '0',
        },
        downPayment: {
            default: '59500',
        },
        mortgageRate: {
            default: '2.25',
        },
        mortgageRateToken: {
            default: '30_FIXED_RATE_350K',
        },
        propertyTaxes: {
            default: '1.2',
        },
        propertyTaxesval: {
            default: '3,640',
        },
        homeInsurance: {
            default: '800',
        },
        hoaFees: {
            default: '0',
        },
        creditScore: {
            default: '2',
        },
        loanTermInYears: {
            default: '30',
        },
        downPaymentTooltip: {
            default: DefaultTooltip.DownPayment,
        },
        loanTypeTooltip: {
            default: DefaultTooltip.LoanType,
        },
        monthlyExpensesTooltip: {
            default: DefaultTooltip.MonthlyExpenses,
        },
        annualIncomeTooltip: {
            default: DefaultTooltip.AnnualIncome,
        },
        privateMortgageInsuranceTooltip: {
            default: DefaultTooltip.PrivateMortgageInsurance,
        },
        debtToIncomeRatioDtiTooltip: {
            default: DefaultTooltip.DebtToIncomeRatioDti,
        },
        showAdvancedOptions: {
            default: false,
        },
        span: {
            type: String,
            default: '',
        },
        recalculateButtonText: {
            default: 'Recalculate',
        },
        zipCode: {
            default: 28277,
        },
        debtToIncome: {
            default: 28,
        },
        ltLogo: {
            default: 0,
        },
        disclosureTokens: {
            default: '1,95',
        },
        disclosureId: {
            default: 'Disclosure01',
        },
        disclosureText: {
            default: 'Disclosures',
        },
        destinationLinkOrId: {
            default: 'wp-mortgage',
        },
        destinationButtonText: {
            default: 'View Free Offers',
        },
        header: {
            default: '',
        },
        subheader: {
            default: '',
        },
        myltexp: {
            default: '0',
        },
        delaySelectOnFocus: {
            default: true,
        },
        showTooltipLoader: {
            default: false,
        },
    },
    data() {
        return {
            hasHeader: false,
            hasSubheader: false,
            AnnualIncome: this.annualIncome,
            MonthlyExpenses: this.monthlyExpenses,
            DownPayment: this.downPayment,
            MortgageRate: this.mortgageRate,
            MortgageRateToken: this.mortgageRateToken,
            PropertyTaxes: this.propertyTaxes,
            PropertyTaxesVal: this.propertyTaxesval,
            HomeInsurance: this.homeInsurance,
            HoaFees: this.hoaFees,
            LoanTermInYears: this.loanTermInYears,
            LoanTermInYearsList: LoanTermList.LoanTermInYearsList.refinance,
            DownPaymentTooltip: parseInt(this.hideTooltip, 10) ? '' : this.downPaymentTooltip,
            AnnualIncomeTooltip: parseInt(this.hideTooltip, 10) ? '' : this.annualIncomeTooltip,
            MonthlyExpensesTooltip: parseInt(this.hideTooltip, 10) ? '' : this.monthlyExpensesTooltip,
            LoanTypeTooltip: parseInt(this.hideTooltip, 10) ? '' : this.loanTypeTooltip,
            PrivateMortgageInsuranceTooltip: parseInt(this.hideTooltip, 10) ? '' : this.privateMortgageInsuranceTooltip,
            DebtToIncomeRatioDtiTooltip: parseInt(this.hideTooltip, 10) ? '' : this.debtToIncomeRatioDtiTooltip,
            ShowAdvancedOptions: this.showAdvancedOptions,
            IsPmiInclude: false,
            DebtToIncome: this.debtToIncome,
            CalculatedValues: {},
            DownpaymentPercentage: '19',
            DisclosureId: this.disclosureId,
            DisclosureText: this.disclosureText,
            DisclosureTokens: this.disclosureTokens,
            DestinationLinkOrId: this.destinationLinkOrId,
            DestinationButtonText: this.destinationButtonText,
            HomePriceMsg: false,
            // Chart data
            chartData: {
                labels: [],
                datasets: [{
                    data: [28, 0, 30, 42],
                    backgroundColor: [
                        '#08c177',
                        '#078181',
                        '#00aeef',
                        '#800080',
                    ],
                    borderWidth: 0,
                }],
            },
            options: {
                cutoutPercentage: 85,
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: false,
                    custom: ChartTooltip.customTooltips,
                },
            },
            chartWidth: this.myltexp === '1' ? 120 : 200,
            chartHeight: this.myltexp === '1' ? 50 : 130,
            // Setting for range slider
            slider: {
                value: 15,
                height: 10,
                sliderStyle: {
                    backgroundColor: '#00aeef',
                },
                bgStyle: {
                    background: 'linear-gradient(90deg, #08c177 28%, #ffc507 51%, #ff704d 79%, #d93551)',
                },
                processStyle: {
                    backgroundColor: 'transparent',
                },
                dotSize: 25,
                tooltip: false,
                clickable: false,
                max: 50,
                min: 15,
            },
        };
    },
    methods: {
        viewMoreClick() {
            this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
        },
        getValue(barValue) {
            this.DebtToIncome = barValue;
            let CurrentValue = barValue;
            while (CurrentValue > 1) {
                CurrentValue /= this.getDivider();
            }
            if (document.getElementById('debt_ratio')) {
                const el = document.getElementById('debt_ratio');
                if (this.percent < 45) {
                    el.style.color = '#08c177';
                } else if (this.percent >= 45 && this.percent < 60) {
                    el.style.color = '#ffc507';
                } else if (this.percent >= 60 && this.percent < 79) {
                    el.style.color = '#ff704d';
                } else {
                    el.style.color = '#d93551';
                }
            }
            TokenService.GetTokenValue(this.MortgageRateToken, (rate) => {
                this.updateMortgageRate(rate);
            });
        },
        getDivider() {
            let sliderLength = this.slider.max.toString().length;
            let divider = 1;
            while (sliderLength > 1) {
                divider *= 10;
                sliderLength--;
            }
            return divider;
        },
        calcualteRates(IsPmiIncludeChanged = false) {
            this.calculateDownPaymentPer(IsPmiIncludeChanged);
            const data = this.generatePostData();
            this.CalculatedValues = CalculatorHelper.calculateHomeRates(data, 'calculate');
            this.chartData.labels = [];
            this.chartData.datasets[0].data = [];
            this.chartData.labels.push(`Monthly Mortgage Payment $${this.CalculatedPayment}`);
            this.chartData.labels.push(`Debt Payments $${this.CalculatedValues.debts}`);
            this.chartData.labels.push(`Income Taxes $${this.CalculatedValues.taxes}`);
            this.chartData.labels.push(`Left Over $${this.CalculatedValues.leftover}`);
            const paymentPercent = Math.round(this.CalculatedPayment / this.CalculatedValues.income * 100);
            const debtPercent = Math.round(this.CalculatedValues.debts / this.CalculatedValues.income * 100);
            const taxesPercent = Math.round(this.CalculatedValues.taxes / this.CalculatedValues.income * 100);
            const leftoverPercent = Math.round(this.CalculatedValues.leftover / this.CalculatedValues.income * 100);
            this.chartData.datasets[0].data.push(paymentPercent);
            this.chartData.datasets[0].data.push(debtPercent);
            this.chartData.datasets[0].data.push(taxesPercent);
            this.chartData.datasets[0].data.push(leftoverPercent);
            // eslint-disable-next-line eqeqeq
            this.HomePriceMsg = !!(this.CalculatedValues.homeprice == 0 || typeof this.CalculatedValues.homeprice == 'string' || isNaN(this.CalculatedValues.homeprice));
            this.$refs.doughnutChart.update();
            const eventDetail = {
                type: 'lendingtree.mortgageui.yantr',
                action: 'home-affordability-data',
                params: {
                    annualIncome: this.AnnualIncome,
                    monthlyDebt: this.MonthlyExpenses,
                    downPayment: this.DownPayment,
                    loanTermInYears: this.LoanTermInYears,
                    affordableHomePrice: this.CalculatedValues.homeprice,
                },
            };
            this.$el.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: eventDetail }));
        },
        currencyFilter(figure) {
            return Accounting.formatNumber(figure);
        },
        resetFilters() {
            this.AnnualIncome = this.formatFigure(this.annualIncome);
            this.MonthlyExpenses = this.formatFigure(this.monthlyExpenses);
            this.DownPayment = this.formatFigure(this.downPayment);
            this.MortgageRate = this.mortgageRate;
            this.PropertyTaxes = parseFloat(this.propertyTaxes).toFixed(2);
            this.PropertyTaxesVal = this.formatFigure(this.propertyTaxesval);
            this.HomeInsurance = this.formatFigure(this.homeInsurance);
            this.HoaFees = this.formatFigure(this.hoaFees);
            this.LoanTermInYears = this.loanTermInYears;
            this.LoanTermInYearsList = LoanTermList.LoanTermInYearsList.refinance;
            this.IsPmiInclude = false;
            this.DebtToIncome = this.debtToIncome;
            this.DownpaymentPercentage = '19';
            // reset slider
            const slider = document.querySelector('.vue-slider');
            const sliderPosition = parseInt(slider.offsetWidth * 0.35, 10);
            document.querySelector('.vue-slider-dot').style.transform = `translateX(${sliderPosition}px)`;
            this.getValue(this.debtToIncome);
        },
        calculateDownPaymentPer(IsPmiIncludeChanged = false) {
            const data = this.generatePostData();
            this.DownpaymentPercentage = CalculatorHelper.calculateHomeRates(data, 'calculateDownpayment');

            if (!IsPmiIncludeChanged && this.DownpaymentPercentage <= 20) {
                this.IsPmiInclude = true;
            }
        },
        calculatePropertyvalue() {
            const data = this.generatePostData();
            this.PropertyTaxesVal = CalculatorHelper.calculateHomeRates(data, 'calculatePropertyTaxval');
        },
        generatePostData() {
            return {
                annualIncome: this.unformatFigure(this.AnnualIncome),
                monthlyExpenses: this.unformatFigure(this.MonthlyExpenses),
                loanterm: this.LoanTermInYears,
                estimatedDownPayment: this.unformatFigure(this.DownPayment),
                hoa: this.unformatFigure(this.HoaFees),
                homeInsurance: this.unformatFigure(this.HomeInsurance),
                mortgageRate: this.MortgageRate,
                propertyTaxes: this.PropertyTaxes,
                propertyTaxesval: this.unformatFigure(this.PropertyTaxesVal),
                pmi: this.IsPmiInclude,
                debtToIncome: this.DebtToIncome,
            };
        },
        updateMortgageRate(rate) {
            this.MortgageRate = rate || this.mortgageRate;
        },
    },
    computed: {
        percent() {
            return (this.DebtToIncome - this.slider.min) / (this.slider.max - this.slider.min) * 100;
        },

        CalculatedPayment() {
            return this.IsPmiInclude ? this.CalculatedValues.payment + this.CalculatedValues.pmi : this.CalculatedValues.payment;
        },
    },
    mounted() {
        this.getValue(this.debtToIncome);
        this.hasHeader = this.header !== '';
        this.hasSubheader = this.subheader !== '';
    },
    updated() {
        this.slider.value = this.debtToIncome;
    },
    watch: {
        AnnualIncome() {
            this.calcualteRates();
        },
        MonthlyExpenses() {
            this.calcualteRates();
        },
        DownPayment() {
            this.calcualteRates();
        },
        MortgageRate() {
            this.calcualteRates();
        },
        PropertyTaxes() {
            this.calcualteRates();
        },
        PropertyTaxesVal() {
            this.calcualteRates();
        },
        HomeInsurance() {
            this.calcualteRates();
        },
        HoaFees() {
            this.calcualteRates();
        },
        LoanTermInYears() {
            this.calcualteRates();
        },
        IsPmiInclude() {
            this.calcualteRates(true);
        },
    },
    components: {
        NumberInput,
        DropDown,
        LtLabel,
        vueSlider,
        LtLogo,
        AdvertisingDisclosures,
        DoughnutChart,
    },
    mixins: [BaseMixin],
};
